import { Box, Typography } from '@mui/material';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import { Order } from '../../../core/types/order';
import { OrderItemType } from '../../../components/orderItem';

export type OrderItemTitleVariant = 'Mobile Number' | 'User ID';

export const useConvertClothing = (
  order: Order,
  titleVariant: OrderItemTitleVariant = 'User ID',
): OrderItemType => {
  const title = `${order.createdByName} - ${
    titleVariant === 'User ID' ? order.employeeId : order.employee.mobilePhoneWork
  }`;

  const obj: OrderItemType = {
    id: order.uid,
    path: `/bestillinger/${order.uid}`,
    status: order.status,
    title,
    type: 'Clothing',
    items: (
      <Box>
        {order.rows.slice(0, 3).map((r) => <Typography key={r.uid}>{`${r.amount} x ${r.description}`}</Typography>)}
        {order.rows.length > 3 && <Typography fontWeight="bold">...</Typography>}
      </Box>
    ),
    totalAmount: order.rows.reduce((acc, curr) => acc + curr.amount, 0),
    icons: (
      <CheckroomIcon color="primary" />
    ),
  };

  return obj;
};
